import React from "react";
import {
  Modal as MUIModal,
  ModalProps as MUIModalProps,
  Stack,
  SxProps,
} from "@mui/material";

import { ModalIDs } from "src/shared/config";
import { useAppDispatch, useAppSelector } from "src/shared/hooks";
import { modalModel } from "src/entities/modal";

type ModalProps = Omit<MUIModalProps, "open"> & {
  modalID: ModalIDs;
  containerSx?: SxProps;
};

export const Modal: React.FC<ModalProps> = (props) => {
  const { modalID, children, containerSx, ...rest } = props;

  const dispatch = useAppDispatch();

  const modal = useAppSelector((state) => {
    return modalModel.selectors.selectModalByID(state, modalID);
  });

  const onClose = () => {
    dispatch(modalModel.actions.closeModal(modalID));
  };

  return (
    <MUIModal {...rest} open={modal.open} onClose={onClose}>
      <Stack
        // width={0.7}
        // height={0.7}
        position="absolute"
        top="50%"
        left="50%"
        bgcolor="background.paper"
        sx={{
          transform: "translate(-50%, -50%)",
          padding: 4,
          ...containerSx,
        }}
      >
        {children}
      </Stack>
    </MUIModal>
  );
};
